export const appHead = {"meta":[{"name":"msapplication-TileColor","content":"white"},{"name":"theme-color","content":"#0f84fa"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1,shrink-to-fit=no,maximum-scale=5,viewport-fit=cover"},{"hid":"og:type","name":"og:type","content":"company"},{"hid":"og:locale","name":"og:locale","content":"fa_IR"},{"hid":"og:image:width","name":"og:image:width","content":"512"},{"hid":"og:image:height","name":"og:image:height","content":"512"},{"hid":"author","name":"author","content":""},{"hid":"theme-color","name":"theme-color","content":"#239ad6"},{"hid":"robots","name":"robots","content":"index, follow"}],"link":[{"rel":"shortcut icon","type":"image/x-icon","href":"/img/Favicon_16.svg"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/img/Favicon_192.svg"},{"rel":"icon","type":"image/png","sizes":"128x128","href":"/icon_x128.png"},{"rel":"icon","type":"image/svg+xml","sizes":"168x168","href":"/img/Favicon_168.svg"},{"rel":"icon","type":"image/svg+xml","sizes":"64x64","href":"/img/Favicon_64.svg"},{"rel":"icon","type":"image/svg+xml","sizes":"32x32","href":"/img/Favicon_32.svg"},{"rel":"icon","type":"image/svg+xml","sizes":"16x16","href":"/img/Favicon_16.svg"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#0f84fa"},{"rel":"preconnect","href":"https://mrbilit.push.adpdigital.com"},{"rel":"preconnect","href":"https://bill.mrbilit.ir"},{"rel":"preconnect","href":"https://audience.yektanet.com"},{"rel":"preconnect","href":"https://ua.yektanet.com"},{"rel":"preconnect","href":"https://certify.alexametrics.com"},{"rel":"apple-touch-icon","sizes":"48x48","href":"/icon_x48.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/icon_x72.png"},{"rel":"apple-touch-icon","sizes":"96x96","href":"/icon_x96.png"},{"rel":"apple-touch-icon","sizes":"128x128","href":"/icon_x128.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/icon_x192.png"},{"rel":"apple-touch-icon","sizes":"167x167","href":"/icon_x192.png"},{"rel":"apple-touch-icon","sizes":"192x192","href":"/icon_x192.png"},{"rel":"apple-touch-icon","sizes":"384x384","href":"/icon_x384.png"},{"rel":"apple-touch-icon","sizes":"512x512","href":"/icon_x512.png"}],"style":[],"script":[{"id":"_webengage_script_tag","type":"text/javascript","innerHTML":"var webengage;!function(e,t,n,i,o){function s(e,t){e[t[t.length-1]]=function(){g.__queue.push([t.join(\".\"),arguments])}}var r,a,g=e[n],l=\"init options track screen onReady\".split(\" \"),c=\"feedback survey notification\".split(\" \"),p=\"options render clear abort\".split(\" \"),u=\"Open Close Submit Complete View Click\".split(\" \"),f=\"identify login logout setAttribute\".split(\" \");if(!g||!g.__v){for(e[n]=g={__queue:[],is_spa:0,__v:\"6.0\",user:{}},r=0;r<l.length;r++)s(g,[l[r]]);for(r=0;r<c.length;r++){for(g[c[r]]={},a=0;a<p.length;a++)s(g[c[r]],[c[r],p[a]]);for(a=0;a<u.length;a++)s(g[c[r]],[c[r],\"on\"+u[a]])}for(r=0;r<f.length;r++)s(g.user,[\"user\",f[r]]);setTimeout(function(){if(window.location.search.includes('layout=mobile')){return;}var e=t.createElement(\"script\"),n=t.getElementById(\"_webengage_script_tag\");e.type=\"text/javascript\",e.async=!0,e.src=(\"https:\"==t.location.protocol?\"https://ssl.widgets.webengage.com\":\"http://cdn.widgets.webengage.com\")+\"/js/webengage-min-v-6.0.js\",n.parentNode.insertBefore(e,n)})}}(window,document,\"webengage\"),webengage.init(\"76aa858\");"}],"noscript":[],"htmlAttrs":{"dir":"rtl","lang":"fa"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = false

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000